import { Reducer } from 'redux';

import { createMarketSymbol, parseMarketSymbol } from '#/lib/exchange';

import { getCurrentMarketByPath } from './currentMarketUtils';
// import { defaultMarket } from '#/config';
// import { switchRouteAction } from '#/reduxState/router/routerReducer';
import { loadMarkets } from './listed/listedMarketsActions';
// import { chainsUrlCodes } from '#/reduxState/exchange/exchangeActiveChainUtils';

// Actions

export const switchCurrentMarket = (base: string, quote: string) => ({
  type: 'SWITCH_MARKET' as const,
  base: base.toUpperCase(),
  quote: quote.toUpperCase(),
  pair: createMarketSymbol(base, quote),
});

type CurrentMarketAction =
  | ReturnType<typeof switchCurrentMarket>
  | ReturnType<typeof loadMarkets>;
// | switchRouteAction;

// Reducer

type CurrentMarketState = {
  readonly base?: string; // IDEX, QNT, LIT, ...
  readonly quote?: string; // ETH, USDT, ...
  readonly pair?: string; // IDEX-ETH format which is used in API requests
};

const initialMarket = getCurrentMarketByPath(window?.location?.pathname);

const defaultState: CurrentMarketState = initialMarket
  ? {
      base: initialMarket.baseSymbol,
      quote: initialMarket.quoteSymbol,
      pair: createMarketSymbol(
        initialMarket.baseSymbol,
        initialMarket.quoteSymbol
      ),
    }
  : {
      base: undefined,
      quote: undefined,
      pair: undefined,
    };

export const currentMarketReducer: Reducer<
  CurrentMarketState,
  CurrentMarketAction
> = (state = defaultState, action): CurrentMarketState => {
  switch (action.type) {
    // We no longer keep router in state
    // case '@@router/LOCATION_CHANGE': {
    //   if (chainsUrlCodes.some(chainShortCode => action.payload.location.pathname.startsWith(`/trade/`))) {
    //     const updatedMarket = getCurrentMarketByPath(
    //       action.payload.location.pathname
    //     );
    //     if (!updatedMarket) {
    //       return state;
    //     }
    //     const { baseSymbol: base, quoteSymbol: quote } = updatedMarket;
    //     return {
    //       base,
    //       quote,
    //       pair: createMarketSymbol(base, quote),
    //     };
    //   }
    //   return state;
    // }
    // Preselect default market as current on non-Dashboard pages
    case 'LOAD_MARKETS': {
      // When already defined, do not change
      if (state.pair) {
        return state;
      }
      const { baseSymbol, quoteSymbol } = parseMarketSymbol(
        action.defaultMarket
      );
      return {
        base: baseSymbol,
        quote: quoteSymbol,
        pair: action.defaultMarket,
      };
    }
    case 'SWITCH_MARKET':
      return {
        quote: action.quote,
        base: action.base,
        pair: createMarketSymbol(action.base, action.quote),
      };
    default:
      return state;
  }
};
